// extracted by mini-css-extract-plugin
module.exports = {"sm":"576px","md":"768px","lg":"992px","popover":"index-module__popover___vbezs","popover-body":"index-module__popover-body___2-q_k"};